<template>
    <div class="form_group">
        <div class="status-error" v-if="hasError('cc-stripe')"> {{getErrorMessage('cc-stripe')}} </div>
        <label for="payment-cc-number">{{ copydeck.component_payment.txt_secure_credit_card_number[lang] }}&nbsp;:</label>

        <div id="payment-cc-number" name="payment-cc-number"  class="stripe-field" data-type="invoice_info"></div>

    </div>
    <!-- div.form_group -->

    <div class="form_group cc_dates_group" aria-labelledby="payment-cc-dates">
        <div id="payment-cc-dates" class="label">{{ copydeck.component_payment.txt_secure_expiration_date[lang] }}&nbsp;&nbsp;:</div>

        <div id="payment-cc-expiry" name="payment-cc-expiry"  class="stripe-field" data-type="invoice_info"></div>
    </div>
    <!-- div.form_group -->

    <div class="form_group">
        <label for="payment-cc-cvv">{{ copydeck.component_payment.txt_secure_ccv[lang] }}:</label>
        <div id="payment-cc-ccv" name="payment-cc-ccv"  class="stripe-field" data-type="invoice_info"></div>
    </div>
    <!-- div.form_group -->
</template>

<script>
export default {
    name: "StripeCardInfo"
}
</script>

<script setup>

import { onMounted } from "vue";
import {useMainStore} from "../stores/main";
import {storeToRefs}  from "pinia";

let props = defineProps(["errors"]);
let store = useMainStore();
let { copydeck, lang, invoice, creditcard } = storeToRefs(store);
let { activateStripe } = store;


function hasError (strKey)
{
    let strError = props.errors[strKey];

    if (strError === undefined)
        return false;



    return strError !== "";
}

function getErrorMessage (strKey)
{
    let strError = props.errors[strKey]

    if (copydeck.value.form_errors[strError])
    {
        return copydeck.value.form_errors[strError][lang.value];
    }

    return "";
}

onMounted (  () =>
            {
                setTimeout( () => activateStripe("#payment-cc-number","#payment-cc-expiry","#payment-cc-ccv"), 100);
            })
</script>
